import * as React from "react";
import { forwardRef } from "react";
const SvgPointerStar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 7.01075L9.48029 4.52688L7.01075 0L4.53047 4.51971L9.53674e-07 6.98925L4.5233 9.46953L6.98925 14L9.47312 9.4767L14 7.01075Z", fill: "#ADB0B5" }));
const ForwardRef = forwardRef(SvgPointerStar);
export default ForwardRef;
